<template>
<main class="lg:mb-[600px] relative z-10 bg-backgroundBody dark:bg-dark">
    
<section
  class="pt-32 lg:pt-[140px] xl:pt-[180px] pb-7 md:pb-16 lg:pb-[88px] xl:pb-[100px] relative overflow-hidden"
>
  <!-- Hero Content Wrapper -->
  <div
    class="flex flex-col gap-y-8 xl:flex-row justify-center md:justify-between items-center pl-10 reveal-me"
  >
    <!-- Text Content Container -->
    <div class="container max-sm:!-ml-[5%] lg:!ml-[10%] xl:!ml-[7%]">
      <!-- Agency Label & Tagline -->
      <div class="flex items-baseline gap-2 md:gap-2 lg:gap-3">
        <p class="font-poppins  tracking-[3px] text-xl md:text-xl lg:text-2xl">
          Shopify
        </p>
        <span class="font-instrument italic text-xl md:text-xl lg:text-2xl">
          Supercharged.
        </span>
      </div>
      <!-- Responsive Headings -->
      <h1 class="mt-2 text-3xl sm:mt-6 sm:text-2xl md:text-3xl lg:hidden block">
        High-Performance Shopify Stores, Built in Los Angeles
      </h1>
      <h1 class="mt-6 text-3xl md:text-5xl lg:text-7xl hidden lg:block">
        High-Performance <br>
        Shopify Stores, Built <br>
        in Los Angeles
        </h1>
        <li
        class="block md:inline-block w-[80%] md:mr-auto md:ml-0 md:w-auto mt-5"
      >
        <a
          href="#shopify-solutions"
          class="rv-button rv-button-primary block md:inline-block text-center"
        >
          <div class="rv-button-top contact-btn-sm">
            <span>Our Work</span>
          </div>
          <div class="rv-button-bottom contact-btn-sm">
            <span>Our Work</span>
          </div>
        </a>
      </li>
    </div>

    <!-- Hero Image -->
    <figure>
      <img src="@/assets/images/home-5/hero-img.jpg" alt="Hero Img" />
    </figure>
  </div>
</section>


<section
    class="pt-14 md:pt-16 lg:pt-[88px] xl:pt-[100px] pb-14 md:pb-16 lg:pb-[88px] xl:pb-[100px] relative overflow-hidden @@Spacing"
  >
    <div class="container">
      <div
        class="flex flex-col md:flex-row gap-y-3 gap-x-10 justify-center lg:justify-start items-start sm:items-center mb-16 md:mb-20"
      >
        <div class="flex-1">
          <h3 class="text-appear-2">
            Everything You Need <br />
            to <span class="font-instrument italic">Succeed</span> On Shopify
          </h3>
        </div>
        <div class="flex-1 max-w-lg">
          <p
            class="text-appear max-md:text-justify dark:text-colorText text-appear-2"
          >
          From custom storefronts to lightning-fast performance, our LA-based team delivers Shopify design, migration, and optimization services built to elevate your brand and drive sales.</p>
        </div>
      </div>
    </div>
  
    <div
      class="flex max-xl:flex-wrap max-xl:gap-5 justify-center [&>*:not(:last-child)]:border-l dark:[&>*:not(:last-child)]:border-l-dark [&>*:last-child]:border-l dark:[&>*:last-child]:border-l-dark [&>*:last-child]:border-r dark:[&>*:last-child]:border-r-dark [&>*]:border-y dark:[&>*]:border-y-dark max-xl:[&>*:first-child]:border-r dark:max-xl:[&>*:first-child]:border-dark max-xl:[&>*:nth-child(2)]:border-r dark:max-xl:[&>*:nth-child(2)]:border-dark max-2xl:[&>*:nth-child(3)]:border-r dark:max-2xl:[&>*:nth-child(3)]:border-dark xl:px-5"
    >
      <!-- Research Card -->
      <div class="relative group overflow-hidden w-[360px] h-[500px] reveal-me">
        <div
          class="w-full h-full flex justify-center items-center absolute translate-y-0 group-hover:-translate-y-full transition-all opacity-100 group-hover:opacity-0 duration-700"
        >
        <div class="flex flex-col items-center">
            <h5 class="max-sm:text-3xl text-center">Store Design <br>& Development</h5>
            <svg
                class="block md:hidden"
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
            >
                <path
                d="M5 16H27"
                class="stroke-black dark:stroke-white"
                stroke-linecap="round"
                stroke-linejoin="round"
                />
                <path
                d="M18 7L27 16L18 25"
                class="stroke-black dark:stroke-white"
                stroke-linecap="round"
                stroke-linejoin="round"
                />
            </svg>
        </div>
           
        </div>
  
        <div
          class="w-full h-full bg-secondary dark:bg-white p-8 absolute translate-y-full duration-700 transition-all group-hover:translate-y-0 group-hover:inset-0 z-10"
        >
            <div class="mb-[35px] flex gap-1 items-center justify-between">
              <h5
                class="max-sm:text-3xl text-white dark:text-secondary opacity-0 translate-y-5 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-[800ms] delay-[240ms]"
              >
              Store Design <br>& Development
              </h5>
              <span
                class="transition-all duration-1000 translate-x-20 group-hover:translate-x-0"
              >
              </span>
            </div>
            <p
              class="text-backgroundBody/70 dark:text-secondary/70 opacity-0 translate-y-5 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-[800ms] delay-[340ms]"
            >
            Turn browsers into buyers with a beautifully designed Shopify storefront built to convert.
            </p>
            <ul
              class="pl-4 mt-6 opacity-0 translate-y-5 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-[800ms] delay-[440ms]"
            >
              <li
                class="text-backgroundBody/70 dark:text-secondary/70 list-disc text-base leading-relexed"
              >
              Bespoke Theme Development – fully custom Shopify themes tailored to your brand</li>
              <li
                class="text-backgroundBody/70 dark:text-secondary/70 list-disc text-base leading-relexed"
              >
              Smart Layout Optimization – strategic placement of CTAs, upsells, and product displays</li>
              <li
              class="text-backgroundBody/70 dark:text-secondary/70 list-disc text-base leading-relexed"
            >
            Interactive Shopping Features – animations, product quick views, and dynamic galleries</li>
            </ul>
        </div>
      </div>
  
      <!-- Alchemy Studio Card -->
      <div class="relative group overflow-hidden w-[360px] h-[500px] reveal-me">
        <div
          class="w-full h-full flex justify-center items-center absolute translate-y-0 group-hover:-translate-y-full transition-all opacity-100 group-hover:opacity-0 duration-700"
        >
        <div class="flex flex-col items-center">
            <h5 class="max-sm:text-3xl text-center">Setup, Migration <br>& Integrations</h5>
            <svg
                class="block md:hidden"
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
            >
                <path
                d="M5 16H27"
                class="stroke-black dark:stroke-white"
                stroke-linecap="round"
                stroke-linejoin="round"
                />
                <path
                d="M18 7L27 16L18 25"
                class="stroke-black dark:stroke-white"
                stroke-linecap="round"
                stroke-linejoin="round"
                />
            </svg>
        </div>
        </div>
  
        <div
          class="w-full h-full bg-secondary dark:bg-white p-8 absolute translate-y-full duration-700 transition-all group-hover:translate-y-0 group-hover:inset-0 z-10"
        >
            <div class="mb-[35px] flex gap-1 items-center justify-between">
              <h5
                class="max-sm:text-3xl text-white dark:text-secondary opacity-0 translate-y-5 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-[800ms] delay-[240ms]"
              >
                Setup, Migration <br>& Integrations
              </h5>
              <span
                class="transition-all duration-1000 translate-x-20 group-hover:translate-x-0"
              >
              </span>
            </div>
            <p
              class="text-backgroundBody/70 dark:text-secondary/70 opacity-0 translate-y-5 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-[800ms] delay-[340ms]"
            >
            Whether you're starting fresh or switching platforms, we handle the heavy lifting to get your Shopify store running seamlessly.</p>
            <ul
              class="pl-4 mt-6 opacity-0 translate-y-5 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-[800ms] delay-[440ms]"
            >
              <li
                class="text-backgroundBody/70 dark:text-secondary/70 list-disc text-base leading-relexed"
              >
              Platform Migrations – move from WooCommerce, Wix, or Squarespace without losing data</li>
              <li
                class="text-backgroundBody/70 dark:text-secondary/70 list-disc text-base leading-relexed"
              >
              App Integrations – Klaviyo, Recharge, Yotpo, reviews, subscriptions, and more</li>
            <li
            class="text-backgroundBody/70 dark:text-secondary/70 list-disc text-base leading-relexed"
          >
          Product & Collection Setup – structured imports, metafields, and variant configuration</li>
            </ul>
        </div>
      </div>
      <!-- Rhythms Media Card -->
      <div class="relative group overflow-hidden w-[360px] h-[500px] reveal-me">
        <div
          class="w-full h-full flex justify-center items-center absolute translate-y-0 group-hover:-translate-y-full transition-all opacity-100 group-hover:opacity-0 duration-700"
        >
        <div class="flex flex-col items-center">
            <h5 class="max-sm:text-3xl text-center">Conversion &<br> Speed Optimization</h5>
            <svg
                class="block md:hidden"
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
            >
                <path
                d="M5 16H27"
                class="stroke-black dark:stroke-white"
                stroke-linecap="round"
                stroke-linejoin="round"
                />
                <path
                d="M18 7L27 16L18 25"
                class="stroke-black dark:stroke-white"
                stroke-linecap="round"
                stroke-linejoin="round"
                />
            </svg>
        </div>
        </div>
  
        <div
          class="w-full h-full bg-secondary dark:bg-white p-8 absolute translate-y-full duration-700 transition-all group-hover:translate-y-0 group-hover:inset-0 z-10"
        >
            <div class="mb-[35px] flex gap-1 items-center justify-between">
              <h5
                class="max-sm:text-3xl text-white dark:text-secondary opacity-0 translate-y-5 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-[800ms] delay-[240ms]"
              >
              Conversion &<br> Speed Optimization
              </h5>
              <span>
              
              </span>
            </div>
            <p
              class="text-backgroundBody/70 dark:text-secondary/70 opacity-0 translate-y-5 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-[800ms] delay-[340ms]"
            >
            We fine-tune your Shopify store to load faster, rank higher, and convert more—turning traffic into revenue.</p>
            <ul
              class="pl-4 mt-6 opacity-0 translate-y-5 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-[800ms] delay-[440ms]"
            >
              <li
                class="text-backgroundBody/70 dark:text-secondary/70 list-disc text-base leading-relexed"
              >
              Site Speed Optimization – faster load times, compressed assets, cleaner code</li>
              <li
                class="text-backgroundBody/70 dark:text-secondary/70 list-disc text-base leading-relexed"
              >
              Conversion Strategy – A/B testing, upsells, cart flow improvements</li>
            <li
            class="text-backgroundBody/70 dark:text-secondary/70 list-disc text-base leading-relexed"
          >
          Technical SEO – structured data, metadata, crawlability fixes</li>
            </ul>
        </div>
      </div>
  
      <!-- Sound Studios  Card -->
  
      <div
        class="relative group overflow-hidden w-[360px] h-[500px] reveal-me justify-self-center"
      >
        <div
          class="w-full h-full flex justify-center items-center absolute translate-y-0 group-hover:-translate-y-full transition-all opacity-100 group-hover:opacity-0 duration-700"
        >
        <div class="flex flex-col items-center">
            <h5 class="max-sm:text-3xl text-center">Ongoing Support <br>& Custom Features</h5>
            <svg
                class="block md:hidden"
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
            >
                <path
                d="M5 16H27"
                class="stroke-black dark:stroke-white"
                stroke-linecap="round"
                stroke-linejoin="round"
                />
                <path
                d="M18 7L27 16L18 25"
                class="stroke-black dark:stroke-white"
                stroke-linecap="round"
                stroke-linejoin="round"
                />
            </svg>
        </div>
        </div>
  
        <div
          class="w-full h-full bg-secondary dark:bg-white p-8 absolute translate-y-full duration-700 transition-all group-hover:translate-y-0 group-hover:inset-0 z-10"
        >
            <div class="mb-[35px] flex gap-1 items-center justify-between">
              <h5
                class="max-sm:text-3xl text-white t dark:text-secondary opacity-0 translate-y-5 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-[800ms] delay-[240ms]"
              >
              Ongoing Support <br>& Custom Features
              </h5>
              <span>
              </span>
            </div>
            <p
              class="text-backgroundBody/70 dark:text-secondary/70 opacity-0 translate-y-5 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-[800ms] delay-[340ms]"
            >
            Keep your store running smoothly and evolving with your brand—no dev team needed.</p>
            <ul
              class="pl-4 mt-6 opacity-0 translate-y-5 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-[800ms] delay-[440ms]"
            >
              <li
                class="text-backgroundBody/70 dark:text-secondary/70 list-disc text-base leading-relexed"
              >
              Maintenance & Updates – bug fixes, seasonal refreshes, new sections</li>
              <li
                class="text-backgroundBody/70 dark:text-secondary/70 list-disc text-base leading-relexed"
              >
              Custom Functionality – build advanced features like bundles, product builders, or gated content</li>
            <li
            class="text-backgroundBody/70 dark:text-secondary/70 list-disc text-base leading-relexed">
                App & API Integrations – connect with CRMs, email tools, inventory systems, or custom APIs</li>
            </ul>
        </div>
      </div>
    </div>
  </section>

 <section id="shopify-solutions"
  class="pt-14 md:pt-16 lg:pt-[88px] xl:pt-[100px] pb-14 md:pb-16 lg:pb-[88px] xl:pb-[100px]"
>
  <div class="container">
    <div class="text-center">
      <div class="rv-badge mb-3 md:mb-8 reveal-me">
        <span class="rv-badge-text">Shopify Projects</span>
      </div>
      <h2 class="mx-auto mb-10 md:mb-20 text-appear">
        Take a Look at the Shopify Stores We've <br />
        Designed, Built, and Scaled to Perform.
      </h2>
    </div>
    <div class="[&>*:not(:last-child)]:mb-4">
      <!-- Card -1 -->
      <div
        class="flex flex-col-reverse md:flex-row items-center border dark:border-dark md:gap-x-11 lg:gap-x-[70px] md:gap-y-10 reveal-me underline-hover-effect group"
      >
        <div class="pl-5 lg:pl-10 max-md:pr-5 max-lg:py-6 flex-1">
          <router-link to="/eoncycle">
            <div class="blog-title mb-6">
              <h3
                class="text[27px] md:text-4xl md:leading-[1.2] md:tracking-[-0.72px]"
              >
              Custom Shopify Build for a Premium eBike Brand
            </h3>
            </div>
          </router-link>
          <p class="border-t dark:border-dark pt-2 md:pt-5">
            From urban grit to refined performance, we’re crafting eoncycle's digital flagship to echo its mission—empowering city riders with style, speed, and zero emissions.
        </p>
        </div>
        <figure
          class="overflow-hidden flex-1 w-full h-full max-md:p-3 max-lg:pr-4"
        >
          <router-link to="/eoncycle" class="block">
            <img
            src="@/assets/images/services/eoncycle-1.png"
            alt="Econcycle product shot"
              class="w-full h-full transition-all duration-500 group-hover:scale-125 group-hover:rotate-3"
            />
          </router-link>
        </figure>
      </div>
      <!-- Card -2 -->
      <div
        class="flex flex-col-reverse md:flex-row items-center border dark:border-dark md:gap-x-11 lg:gap-x-[70px] md:gap-y-10 reveal-me underline-hover-effect group"
      >
        <div class="pl-5 lg:pl-10 max-md:pr-5 max-lg:py-6 flex-1">
          <router-link to="/off-melrose">
            <div class="blog-title mb-6">
              <h3
                class="text[27px] md:text-4xl md:leading-[1.2] md:tracking-[-0.72px]"
              >
              Modern Shopify Design for a Women’s Fashion Label
             </h3>
            </div>
        </router-link>
          <p class="border-t dark:border-dark pt-2 md:pt-5">
            From playful elegance to modern ease, we’re designing Off Melrose to deliver a shopping experience that reflects the vibe of LA streetwear meets boutique chic.
                  </p>
        </div>
        <figure
          class="overflow-hidden flex-1 w-full h-full max-md:p-3 max-lg:pr-4"
        >
          <router-link to="/off-melrose" class="block">
            <img
              src="@/assets/images/services/off-melrose-1.png"
              alt="Off Melrose Product Screenshot"
              class="w-full h-full transition-all duration-500 group-hover:scale-125 group-hover:rotate-3"
            />
          </router-link>
        </figure>
      </div>
    </div>
  </div>
</section>
 <!--=====================================
   The Process Section
======================================-->

<section
  class="pt-14 md:pt-16 lg:pt-[88px] xl:pt-[100px] pb-14 md:pb-16 lg:pb-[88px] xl:pb-[100px] relative overflow-hidden"
>
  <div
    class="absolute max-lg:scale-y-[2.8] -z-30 scale-x-[2.2] left-1/2 top-1/2 -translate-y-1/2 -translate-x-1/2"
  >
    <img src="@/assets/images/gradient-bg.png" alt="gradient-bg" />
  </div>
  <div class="container">
    <!-- Section Header -->
    <div
      class="flex flex-col md:flex-row gap-x-10 gap-y-4 justify-center lg:justify-between items-start mb-16 lg:mb-24"
    >
      <!-- Title Area -->
      <div class="flex-1 md:self-start">
        <h2 class="text-appear">
          <span class="font-instrument italic font-medium"> The Flow — </span>
          <br class="hidden md:block" />
          Our Process
        </h2>
      </div>

      <!-- Description -->
      <div class="flex-1 md:self-end">
        <p class="text-appear dark:text-colorText max-w-lg">
            This isn’t just Shopify. It’s your brand’s best version online.
            Built to look sharp, move fast, and drive results.
        </p>
      </div>
    </div>

    <!-- Services Grid -->
    <div
      class="grid grid-cols-12 justify-center items-center gap-[1px] reveal-me"
    >
      <!-- Discovery Service Card -->
      <div
        class="col-span-full max-sm:border-x max-sm:border-t max-sm:border-dark/5 sm:col-span-6 lg:col-span-4 xl:col-span-3 px-7 md:px-10 pt-7 md:pt-10 pb-4 md:pb-16 bg-white/80 backdrop-blur dark:bg-dark hover:bg-primary dark:hover:bg-primary group transition-all duration-300 ease-in-out min-h-[230px] sm:min-h-[400px]"
      >
        <h4
          class="md:text-[37px] dark:group-hover:text-secondary transition-colors duration-300 leading-[1.2] pb-3"
        >
          Discovery
        </h4>
        <div class="rv-badge  md:mb-4">
            <span class="rv-badge-text">Free Consult</span>
        </div>
        <p
          class="text-[17px] leading-[25.5px] text-[#000000b3] dark:text-dark-100 dark:group-hover:text-dark-200 transition-colors duration-300 font-medium italic"
        >
            This is where we dive into your story, understand your brand, goals, and challenges. We align on what matters most and set the foundation for everything that follows.
        </p>
      </div>

      <!-- Strategy Service Card -->
      <div
        class="col-span-full max-sm:border-x max-sm:border-t max-sm:border-dark/5 sm:col-span-6 lg:col-span-4 xl:col-span-3 px-7 md:px-10 pt-7 md:pt-10 pb-4 md:pb-16 bg-white/80 dark:bg-dark hover:bg-primary dark:hover:bg-primary group transition-all duration-300 ease-in-out min-h-[230px] sm:min-h-[400px]"
      >
        <h4
          class="md:text-[37px] dark:group-hover:text-secondary transition-colors duration-300 leading-[1.2] pb-3 md:mb-4"
        >
          Design
        </h4>
        <p
          class="text-[17px] leading-[25.5px] text-[#000000b3] dark:text-dark-100 dark:group-hover:text-dark-200 transition-colors duration-300 font-medium italic"
        >
         Design is where vision takes form. We turn ideas into clean, conversion-ready interfaces that feel on-brand, intuitive, and built to sell. Every layout, font, and micro-interaction is built to convert.
        </p>
      </div>

      <!-- Build Service Card -->
      <div
        class="col-span-full max-sm:border-x max-sm:border-t max-sm:border-dark/5 sm:col-span-6 lg:col-span-4 xl:col-span-3 px-7 md:px-10 pt-7 md:pt-10 pb-4 md:pb-16 bg-white/80 dark:bg-dark hover:bg-primary dark:hover:bg-primary group transition-all duration-300 ease-in-out min-h-[230px] sm:min-h-[400px]"
      >
        <h4
          class="md:text-[37px] dark:group-hover:text-secondary transition-colors duration-300 leading-[1.2] pb-3 md:mb-4"
        >
          Develope
        </h4>
        <p
          class="text-[17px] leading-[25.5px] text-[#000000b3] dark:text-dark-100 dark:group-hover:text-dark-200 transition-colors duration-300 font-medium italic"
        >
            From Figma to fully functional. We develop every page, section, and feature with performance in mind—optimized for speed, SEO, and mobile-first usability.
        </p>
      </div>

      <!-- Design Service Card -->
      <div
        class="col-span-full max-sm:border-x max-sm:border-t max-sm:border-b max-sm:border-dark/5 sm:col-span-6 lg:col-span-4 xl:col-span-3 px-10 pt-10 pb-16 bg-white/80 dark:bg-dark hover:bg-primary dark:hover:bg-primary group transition-all duration-300 ease-in-out min-h-[230px] sm:min-h-[400px]"
      >
        <h4
          class="md:text-[37px] dark:group-hover:text-secondary transition-colors duration-300 leading-[1.2] pb-3 md:mb-4"
        >
          Refine
        </h4>
        <p
          class="text-[17px] leading-[25.5px] text-[#000000b3] dark:text-dark-100 dark:group-hover:text-dark-200 transition-colors duration-300 font-medium italic"
        >
            Refinement is where good becomes great. After launch, we fine-tune speed, UX, and conversions—because top-performing stores are always evolving.        
        </p>
      </div>
    </div>

    <!-- CTA Button -->
    <ul class="flex justify-center mt-[60px]">
      <li class="block md:inline-block w-[90%] mx-auto md:w-auto">
        <router-link
          to="/contact"
          class="rv-button rv-button-secondary block md:inline-block"
        >
          <div class="rv-button-top !text-center">
            <span>Start Your Project</span>
          </div>
          <div class="rv-button-bottom !text-center">
            <span>Start Your Project</span>
          </div>
        </router-link>
      </li>
    </ul>
  </div>
</section>


 <!--=====================================
   Our Edge Section
======================================-->
<section
  class="pt-14 md:pt-16 lg:pt-[88px] xl:pt-[100px] pb-14 md:pb-16 lg:pb-[88px] xl:pb-[100px]"
>
  <div class="container">
    <div class="text-center mb-10 md:mb-20">
      <div class="rv-badge mb-3 md:mb-8 reveal-me">
        <span class="rv-badge-text">Our Edge</span>
      </div>
      <h2 class="text-appear">
        Why Brands Trust Us to Build Their Shopify Stores
      </h2>
    </div>

    <!-- Services Container -->
    <div
      class="max-w-[1170px] w-full mx-auto [&>*:not(:last-child)]:mb-6 reveal-me"
    >
        <div
            class="bg-white dark:bg-dark border border-secondary/10 dark:border-backgroundBody/10 transition-all duration-300"
            >
            <div
                class="relative group z-10 cursor-pointer py-10 px-5 md:px-10 flex justify-between items-center flex-col md:flex-row"
            >
                <div
                class="absolute inset-0 opacity-0  bg-cover transition-opacity duration-700 in-expo group-hover:opacity-100"
                :style="{ backgroundImage: `url(${laBased})` }"
                ></div>

                <div class="relative z-10 w-full md:w-1/2">
                <h3
                    class="font-medium text-[25px] md:text-4xl lg:text-[42px] xl:text-5xl leading-[25.2px] md:leading-[1.2] transition-colors duration-700 group-hover:text-white"
                >
                LA-Based
                </h3>
                </div>

                <div class="relative z-10 w-full md:w-1/2 mt-4 md:mt-0">
                <p
                    class="text-base md:text-xl md:leading-[1.4] md:tracking-[0.4px] transition-colors duration-700 group-hover:text-white"
                >
                We’re local, accessible, and understand the fast-moving LA market.
            </p>
                </div>
            </div>
        </div>
        <div
            class="bg-white dark:bg-dark border border-secondary/10 dark:border-backgroundBody/10 transition-all duration-300"
            >
            <div
                class="relative group z-10 cursor-pointer py-10 px-5 md:px-10 flex justify-between items-center flex-col md:flex-row"
            >
                <div
                class="absolute inset-0 opacity-0 bg-cover transition-opacity duration-700 in-expo group-hover:opacity-100"
                :style="{ backgroundImage: `url(${exceptionalQuality})` }"

                ></div>

                <div class="relative z-10 w-full md:w-1/2">
                <h3
                    class="font-medium text-[25px] md:text-4xl lg:text-[42px] xl:text-5xl leading-[25.2px] md:leading-[1.2] transition-colors duration-700 group-hover:text-white"
                >
                Exceptional Quality
                </h3>
                </div>

                <div class="relative z-10 w-full md:w-1/2 mt-4 md:mt-0">
                <p
                    class="text-base md:text-xl md:leading-[1.4] md:tracking-[0.4px] transition-colors duration-700 group-hover:text-white"
                >
                Every detail—from code to design—is built to last and optimized for real-world performance.</p>
                </div>
            </div>
        </div>
        <div
            class="bg-white dark:bg-dark border border-secondary/10 dark:border-backgroundBody/10 transition-all duration-300"
            >
            <div
                class="relative group z-10 cursor-pointer py-10 px-5 md:px-10 flex justify-between items-center flex-col md:flex-row"
            >
                <div
                class="absolute inset-0 opacity-0 bg-cover transition-opacity duration-700 in-expo group-hover:opacity-100"
                :style="{ backgroundImage: `url(${quickTurnaround})` }"

                ></div>

                <div class="relative z-10 w-full md:w-1/2">
                <h3
                    class="font-medium text-[25px] md:text-4xl lg:text-[42px] xl:text-5xl leading-[25.2px] md:leading-[1.2] transition-colors duration-700 group-hover:text-white"
                >
                    Quick Turnaround
                </h3>
                </div>

                <div class="relative z-10 w-full md:w-1/2 mt-4 md:mt-0">
                <p
                    class="text-base md:text-xl md:leading-[1.4] md:tracking-[0.4px] transition-colors duration-700 group-hover:text-white"
                >
                    We move fast—without sacrificing quality or attention to detail.
                </p>
                </div>
            </div>
        </div>
        <div
            class="bg-white dark:bg-dark border border-secondary/10 dark:border-backgroundBody/10 transition-all duration-300"
            >
            <div
                class="relative group z-10 cursor-pointer py-10 px-5 md:px-10 flex justify-between items-center flex-col md:flex-row"
            >
                <div
                class="absolute inset-0 opacity-0 bg-cover transition-opacity duration-700 in-expo group-hover:opacity-100"
                :style="{ backgroundImage: `url(${provenResults})` }"

                ></div>

                <div class="relative z-10 w-full md:w-1/2">
                <h3
                    class="font-medium text-[25px] md:text-4xl lg:text-[42px] xl:text-5xl leading-[25.2px] md:leading-[1.2] transition-colors duration-700 group-hover:text-white"
                >
                    Proven Results
                </h3>
                </div>

                <div class="relative z-10 w-full md:w-1/2 mt-4 md:mt-0">
                <p
                    class="text-base md:text-xl md:leading-[1.4] md:tracking-[0.4px] transition-colors duration-700 group-hover:text-white"
                >
                    Real stores, real sales, real success stories.
                </p>
                </div>
            </div>
        </div>

    </div>
  </div>
</section>


 
 <!--=====================================
   FAQ Section
======================================-->
<section
  class="pt-14 md:pt-16 lg:pt-[88px] xl:pt-[100px] pb-14 md:pb-16 lg:pb-[88px] xl:pb-[100px] relative @@faqSpacing"
>
  <div
    class="absolute scale-y-[3.5] sm:scale-y-[2.2] md:scale-y-[1.6] xl:scale-y-[1.4] scale-x-[1.7] left-1/2 top-1/2 max-md:-translate-y-[45%] md:-translate-y-1/2 -translate-x-1/2 -z-30"
  >
    <img src="@/assets/images/gradient-bg.png" alt="gradient-bg" />
  </div>
  <div class="container">
    <!-- FAQ Section Title -->
    <div class="text-center hidden">
      <div class="rv-badge mb-3 lg:mb-7 reveal-me">
        <span class="rv-badge-text">Faq</span>
      </div>
    </div>
    <h1 class="mb-10 md:mb-20 text-center lg:text-[84px] text-appear-2">
      Frequently Asked Questions
    </h1>

    <!-- FAQ Items Container -->
    <div
      class="max-w-[900px] w-full mx-auto [&>*:not(:last-child)]:mb-6 reveal-me"
    >
      <!-- FAQ Item 1 -->
      <div
        class="accordion-item overflow-hidden bg-backgroundBody dark:bg-dark border border-white dark:border-[#151515] duration-300"
      >
        <div
          class="accordion-header relative cursor-pointer py-5 md:py-[35px] max-md:px-5 md:px-10"
        >
          <h3
            class="text-xl md:text-[25px] font-normal sm:font-bold md:leading-[25.2px] md:tracking-normal max-md:inline-block max-lg:pr-10"
          >
          How long does a custom Shopify store take to build?
        </h3>
          <div class="accordion-header-icon dark:border-dark"></div>
        </div>
        <p
          class="accordion-body max-md:text-sm max-md:px-5 md:px-10 duration-300 h-0"
        >
        Timelines depend on the complexity of the project, but most custom builds take between 3 to 6 weeks. This includes planning, design, development, revisions, and final launch. Faster turnarounds are possible for leaner setups or theme-based work.
        </p>
      </div>

      <!-- FAQ Item 2 -->
      <div
        class="accordion-item overflow-hidden bg-backgroundBody dark:bg-dark border border-white dark:border-[#151515] duration-300"
      >
        <div
          class="accordion-header relative cursor-pointer py-5 md:py-[35px] max-md:px-5 md:px-10"
        >
          <h3
            class="text-xl md:text-[25px] font-normal sm:font-bold md:leading-[25.2px] md:tracking-normal max-md:inline-block max-lg:pr-10"
          >
          Can you migrate my store without losing products or SEO?
        </h3>
          <div class="accordion-header-icon dark:border-dark"></div>
        </div>
        <p
          class="accordion-body max-md:text-sm max-md:px-5 md:px-10 duration-300 h-0"
        >
            Yes, we specialize in safe and seamless migrations. All your products, collections, customers, orders, and SEO metadata (like page titles and URLs) are preserved. We also set up proper 301 redirects to protect your search rankings.
        </p>
      </div>

      <!-- FAQ Item 3 -->
      <div
        class="accordion-item overflow-hidden bg-backgroundBody dark:bg-dark border border-white dark:border-[#151515] duration-300"
      >
        <div
          class="accordion-header relative cursor-pointer py-5 md:py-[35px] max-md:px-5 md:px-10"
        >
          <h3
            class="text-xl md:text-[25px] font-normal sm:font-bold md:leading-[25.2px] md:tracking-normal max-md:inline-block max-lg:pr-8"
          >
              What kind of ongoing support do you offer?
          </h3>
          <div class="accordion-header-icon dark:border-dark"></div>
        </div>
        <p
          class="accordion-body max-md:text-sm max-md:px-5 md:px-10 duration-300 h-0"
        >
            We provide ongoing maintenance for bug fixes, performance tuning, and updates. We also handle seasonal refreshes (like holiday sales), app installs, and new feature development so your store keeps evolving without needing an in-house dev team.
        </p>
      </div>

      <!-- FAQ Item 4 -->
      <div
        class="accordion-item overflow-hidden bg-backgroundBody dark:bg-dark border border-white dark:border-[#151515] duration-300"
      >
        <div
          class="accordion-header relative cursor-pointer py-5 md:py-[35px] max-md:px-5 md:px-10"
        >
          <h3
            class="text-xl md:text-[25px] font-normal sm:font-bold md:leading-[25.2px] md:tracking-normal max-md:inline-block max-lg:pr-8"
          >
            How involved will I be in the project?
          </h3>
          <div class="accordion-header-icon dark:border-dark"></div>
        </div>
        <p
          class="accordion-body max-md:text-sm max-md:px-5 md:px-10 duration-300 h-0"
        >
          We value collaboration and will keep you updated at every stage. Your
          input is crucial to ensure we align with your vision and goals.
        </p>
      </div>

      <!-- FAQ Item 5 -->
      <div
        class="accordion-item overflow-hidden bg-backgroundBody dark:bg-dark border border-white dark:border-[#151515] duration-300"
      >
        <div
          class="accordion-header relative cursor-pointer py-5 md:py-[35px] max-md:px-5 md:px-10"
        >
          <h3
            class="text-xl md:text-[25px] font-normal sm:font-bold md:leading-[25.2px] md:tracking-normal max-md:inline-block max-lg:pr-8"
          >
          Can you integrate third-party tools with my store?
        </h3>
          <div class="accordion-header-icon dark:border-dark"></div>
        </div>
        <p
          class="accordion-body max-md:text-sm max-md:px-5 md:px-10 duration-300 h-0"
        >
            Absolutely. We’ve integrated email platforms (like Klaviyo), subscription apps (like Recharge), CRMs, inventory systems, and custom APIs. If it connects to Shopify or can be extended with code, we can handle it.
        </p>
      </div>
    </div>
  </div>
</section>


<!--=====================================
   CTA Section
======================================-->
<section
  class="pt-14 md:pt-16 lg:pt-[88px] xl:pt-[100px] pb-[70px] lg:pb-[140px] relative"
>
  <div class="container">
    <div class="text-center">
      <div class="rv-badge reveal-me">
        <span class="rv-badge-text">Free Consultation</span>
      </div>
    </div>
    <!-- CTA Heading -->
    <h2
      class="text-center xl:text-[96px] font-normal xl:leading-[1.1] xl:tracking-[-2.88px]"
    >
      Got Questions?
      <span class="font-instrument sm:mt-10 italic block max-md:inline-block"
        >We’ve Got Answers</span
      >
    </h2>

    <ul
    class="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-6 list-none"
  >
      <!-- Primary CTA Button -->
      <li
        class="block md:inline-block w-[90%] mx-auto md:ml-auto md:mr-0 md:w-auto"
      >
      
      </li>
      <!-- Secondary CTA Button -->
      <li
        class="block md:inline-block w-[90%] mx-auto md:mr-auto md:ml-0 md:w-auto"
      >
        <router-link
          to="/contact"
          class="rv-button rv-button-primary block md:inline-block"
        >
          <div class="rv-button-top contact-btn-lg">
            <span>Let's Connect</span>
          </div>
          <div class="rv-button-bottom contact-btn-lg">
            <span>Let's Connect</span>
          </div>
        </router-link>
      </li>
    </ul>
  </div>
</section>
</main>

<!--=====================================
   Footer Section
======================================-->
<FooterComponent/>


</template>
<script>
import FooterComponent from '@/components/FooterComponent.vue'
import laBased from '@/assets/images/services/la-based.png' 
import exceptionalQuality from '@/assets/images/services/abstract-wave.png' 
import quickTurnaround from '@/assets/images/services/quick-turnaround.png' 
import provenResults from '@/assets/images/services/proven-results.png' 
import { Components } from '@/legacy/initLegacy'   // ← new import

export default {
  name: 'BlingGram',
  components: {
    FooterComponent
  },
  mounted() {
    // wait until our template is rendered, then wire up the FAQ
    this.$nextTick(() => {
      Components.initFAQ()
    })
  },
  data() {
    return {
        laBased,exceptionalQuality,quickTurnaround,provenResults
    }
  }
}
</script>